module.exports = __webpack_public_path__ + "img/mail_box_text_box_closed.30a15969.png";